import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  MenuController,
  ToastController,
  Platform,
  IonicModule,
} from '@ionic/angular';
import { Network } from '@capacitor/network';
import { ConnectionstatusService } from './services/connection-status/connectionstatus.service';
import { Device } from '@capacitor/device';
import { SplashScreen } from '@capacitor/splash-screen';
import { environment } from '../environments/environment';
import { LogoutComponent } from './components/logout/logout.component';
import { StorageService } from './services/storage/storage.service';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { ScanService } from './services/scan/scan.service';
import { TextStringsService } from './services/text-strings/text-strings.service';
import { LoggedInUserComponent } from './components/logged-in-user/logged-in-user.component';
import { ModalController } from '@ionic/angular';

// import { IonIcon } from "@ionic/angular/standalone";

import { addIcons } from 'ionicons';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonicModule, RouterLink, LoggedInUserComponent, LogoutComponent],
})
export class AppComponent {
  appInfo = environment.appVersion; // default to web version from package.json

  constructor(
    public menuCtrl: MenuController,
    private connectionstatusService: ConnectionstatusService,
    private storage: StorageService,
    public auth: AuthService,
    public platform: Platform,
    public router: Router,
    private scanService: ScanService,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    public txt: TextStringsService
  ) {
    this.platform.ready().then(() => {
      console.log('platform ready---');
      this.menuCtrl.enable(true, 'main-more-menu');
      // setTimeout(() => {
      SplashScreen.hide();
      // }, 2000);
    });

    addIcons({
      overview: 'assets/icons/custom-home.svg',
      scan: 'assets/icons/custom-scan.svg',
      gear: 'assets/icons/custom-settings.svg',
      truck: 'assets/icons/custom-truck.svg',
      order: 'assets/icons/custom-basket.svg',
      history: 'assets/icons/custom-history.svg',
      contact: 'assets/icons/custom-contact.svg',
      help: 'assets/icons/custom-help.svg',
      account: 'assets/icons/custom-account.svg',
      legal: 'assets/icons/custom-legal.svg',
    });
  }

  async ngOnInit() {
    // await SplashScreen.show({
    //   showDuration: 2000,
    //   autoHide: true,
    // });
    // console.log('enabling menu from nginit')
    // this.menuCtrl.enable(true, 'main-more-menu');
    //console.log(this.router.url)
    // listen to network status, and set val to service
    // Initialize the flag with the ACTUAL status: it used to default to
    // "online" until the first change event, so an app cold-started offline
    // sent scans into the void instead of queueing them.
    Network.getStatus().then((status) => {
      this.connectionstatusService.connected = !!status?.connected;
      if (status?.connected) {
        // Cold start while online: flush any backlog from the last session
        this.resendOfflineScans();
      }
    });
    Network.addListener('networkStatusChange', (status) => {
      const nowConnected = !!status?.connected;
      const wasConnected = this.connectionstatusService.connected;
      this.connectionstatusService.connected = nowConnected;

      // Resend the offline queue only on the offline -> online TRANSITION.
      // Android fires networkStatusChange liberally (Wi-Fi roaming, app
      // resume) while staying connected — every event used to retrigger a
      // resend attempt and its toast.
      if (nowConnected && !wasConnected) {
        this.resendOfflineScans();
      }
    });
    // await this.storage.create();
    this.logDeviceInfo();
    console.log(this.router);
  }

  private resendInFlight = false;

  private resendOfflineScans() {
    if (this.resendInFlight) {
      return;
    }
    this.storage
      .get('offLineScans')
      .then((res: any) => {
        const queued = res == null ? [] : JSON.parse(res);
        if (queued.length) {
          this.resendInFlight = true;
          this.saveOfflineScans(queued).finally(
            () => (this.resendInFlight = false)
          );
        }
      })
      .catch((error: any) => {
        console.log('err getting saveOfflineItems', error);
      });
  }

  public async saveOfflineScans(scans: Array<any>) {
    const results = await Promise.allSettled(
      scans.map((code) => this.scanService.sendScan(code))
    );
    const countSucceses = results.filter(
      (obj) => obj.status == 'fulfilled'
    ).length;
    // Split the failures: if the backend ANSWERED with an error the scan is
    // permanently rejected — retrying can never succeed, so drop it from the
    // queue (a poison entry used to be retried and toasted forever). Only
    // network-level failures (no response: offline, timeout) stay queued.
    const rejectedByServer: any[] = [];
    const retryable: any[] = [];
    results.forEach((r: any, i) => {
      if (r.status !== 'rejected') {
        return;
      }
      if (r.reason?.response) {
        rejectedByServer.push(scans[i]);
      } else {
        retryable.push(scans[i]);
      }
    });
    if (retryable.length) {
      this.storage.set(
        'offLineScans',
        JSON.stringify(Array.from(new Set(retryable)))
      );
    } else {
      this.storage.delete('offLineScans');
    }
    // Toast only when something actually HAPPENED (sent or dropped).
    // "Still can't reach the server" retries stay silent instead of
    // re-announcing themselves on every reconnect.
    if (countSucceses > 0 || rejectedByServer.length > 0) {
      let msg = 'Der var ' + countSucceses + ' der blev sendt ind';
      if (rejectedByServer.length) {
        msg +=
          '\nAfvist af systemet og fjernet fra køen: ' +
          rejectedByServer.join(', ');
      }
      if (retryable.length) {
        msg += '\nDer var ' + retryable.length + ' der venter på nyt forsøg';
      }
      this.showToast(msg);
    }
  }
  async showToast(message: string) {
    const toast = await this.toastController.create({
      message:
        'Vi har gemt nogle scans du havde lavet mens du var offline \n' +
        message,
      header: 'Gemt offline items',
      duration: 5000,
      cssClass: 'toastMultiLine',
      position: 'top',
    });
    await toast.present();
  }
  // get device uuid
  public logDeviceInfo = async () => {
    const deviceId = await Device.getId();
    // put in persitant storage
    // console.log('now setting device id');
    // console.log(deviceId?.identifier);
    // alert(deviceId?.identifier);
    this.storage.set('deviceId', deviceId?.identifier);
    this.auth.deviceId = deviceId?.identifier;
  };

  toggleSideMenu() {
    // console.log('toggle menu')
    this.menuCtrl.toggle('main-more-menu');
    // console.log('menu isOpen', this.menuCtrl.isOpen())
  }
  public onMenuOpen() {
    // console.log('menu WILL open')
    //.barcode-scanning-modal
    document
      .querySelector('.barcode-scanning-modal')
      ?.classList.add('lowerZindex');
    // console.log('menu isOpen', this.menuCtrl.isOpen())
  }
  public menuClosed() {
    // console.log('menu DID close')
    document
      .querySelector('.barcode-scanning-modal')
      ?.classList.remove('lowerZindex');
    // console.log('menu isOpen', this.menuCtrl.isOpen())
  }
  async openProfileModal() {
    this.toggleSideMenu();
    const modal = await this.modalCtrl.create({
      component: LoggedInUserComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      // this.message = `Hello, ${data}!`;
    }
  }
}
